import { createFileRoute } from '@tanstack/react-router';

import { IntegrationsTable } from '../features/demand/integrations/components/IntegrationsTable/IntegrationsTable';
import { integrationsRouteSearchSchema } from '../features/demand/integrations/integrationsRouteSearch';

export const Route = createFileRoute('/demand/integrations/')({
  validateSearch: integrationsRouteSearchSchema,
  component: IntegrationsTable,
});
